import ReCAPTCHA from 'react-google-recaptcha';
import { Button, ButtonVariants } from '../../../../../Atoms/Button';
import If from '../../../../../Atoms/Conditionals/If';
import { InputField } from './input-field';
import { useLeadForm } from '../../../../../../hooks/useLeadForm';

const CorporateLeadsForm = () => {
  const {
    formData,
    isSubmitting,
    isSubmitted,
    recaptchaRef,
    handleInputChange,
    handleSubmit,
  } = useLeadForm({
    formType: 'marketing_webinar_topbanner',
    leadType: 'advance_tax_december_2025',
    initialFormData: {
      phoneNumber: '',
      emailId: '',
    },
    fieldMapping: {
      phone_number: 'phoneNumber',
      office_email: 'emailId',
    },
  });

  return (
    <div className="bg-white shadow-lg md:shadow-none md:rounded-none rounded-md py-8">
      <div className="mx-10 sm:mx-4">
        <If condition={isSubmitted}>
          <div className="bg-white w-full max-w-[700px] flex flex-col items-center justify-center rounded-lg h-44 text-[#020518] lg:w-[700px] md:my-12 md:w-[614px] sm:h-[292px]">
            <div className="mb-2">
              <img
                src="https://assets1.cleartax-cdn.com/cleartax/images/1674553598_completedicon.png"
                width="105px"
                alt="Success"
              />
            </div>
            <div>
              <div className="text-[#020518] mb-2 flex justify-center">
                Our team will reach out to you shortly.
              </div>
            </div>
          </div>
        </If>

        <If condition={!isSubmitted}>
          <form
            onSubmit={handleSubmit}
            className="flex flex-wrap justify-between"
          >
            <div className="mr-5 basis-[46%] sm:basis-full md:basis-full md:mr-0 sm:mr-0">
              <InputField
                id="phone_number"
                label="Phone Number"
                type="tel"
                placeholder="Your contact number"
                value={formData.phoneNumber || ''}
                onChange={handleInputChange}
                required
                title="Phone number should be 10 digits"
                pattern="[0-9]{10}"
              />
            </div>

            <div className="basis-[46%] sm:basis-full md:basis-full">
              <InputField
                id="office_email"
                label="Email ID"
                type="email"
                placeholder="Your email ID"
                value={formData.emailId || ''}
                onChange={handleInputChange}
                required
                title="Email should be of the format mailid@company.xyz"
              />
            </div>

            <div className="basis-full">
              <div className="py-2 cursor-pointer pt-5 sm:pt-4">
                <Button
                  variant={ButtonVariants.bluefilled}
                  rounded="sm"
                  className="w-full text-base font-bold h-12 py-0"
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Submitting...' : 'Request a Callback'}
                </Button>
              </div>
            </div>
          </form>
        </If>
      </div>

      <ReCAPTCHA
        sitekey="6LevgAErAAAAAKzR-MPcdXwti7lpxV3-jOPM0vL2"
        size="invisible"
        ref={recaptchaRef}
      />
    </div>
  );
};

export default CorporateLeadsForm;
